import React from 'react';
import {Dimmer, Loader} from 'semantic-ui-react';
import {CenteredContent} from '../CenteredContent.js';

export const LoadingScreen = ({size, ...props}) => {

    return (
        <CenteredContent>
            <Dimmer active inverted>
                <Loader active size={size || 'large'} {...props} />
            </Dimmer>
        </CenteredContent>
    );
};